"use client";

import * as React from "react";

import { MenuItems } from "@headlessui/react";

import { cn } from "@/shared/helpers/cn.helper";

export interface IDropdownItemsProps extends React.ComponentProps<typeof MenuItems> {
  className?: string;
}

const DropdownItems = React.forwardRef<HTMLDivElement, IDropdownItemsProps>(({ className, ...props }, ref) => {
  const hasAnchor = "anchor" in props && props.anchor !== undefined;

  return (
    <MenuItems
      ref={ref}
      className={cn(
        "z-50 flex w-max min-w-0 flex-col rounded-xl border border-light-100 bg-white shadow-lg",
        hasAnchor ? "mt-2" : "absolute right-0 my-3",
        className,
      )}
      {...props}
    />
  );
});

DropdownItems.displayName = "DropdownItems";

export { DropdownItems };
